import PermissionsState from 'redux/permissions/interfaces/permissionsState';

const INIT_PERMISSIONS_STATE: PermissionsState = {
  catalogs: null,
  hardPermissions: null,
  guestPermissions: null,
};

export default INIT_PERMISSIONS_STATE;
